import styled from "styled-components";
import { BoxShadow, BoxShadowHover } from "../../../../../../../styles/common/mixins/box-shadow.styled.js";
import { FlexMixin, FontMixin } from "../../../../../../../styles/common/mixins/helpers.styled.js";
import { BorderRadius } from "../../../../../../../styles/common/mixins/logical.styled.js";
export const CardBox = styled.div.withConfig({
    displayName: "styled__CardBox",
    componentId: "sc-94321db8-0"
})`
	display: block;
	height: 100%;
	padding: 2px;
	position: relative;
`;
export const CardWrapper = styled.article.withConfig({
    displayName: "styled__CardWrapper",
    componentId: "sc-94321db8-1"
})`
	${BorderRadius({
    all: '4px'
})}
	${BoxShadowHover}
	${BoxShadow}
	${FlexMixin({
    direction: 'column'
})}
	background-color: ${({ theme  })=>theme.colors.white.base};
	height: 100%;
	overflow: hidden;
`;
export const CardLink = styled.a.withConfig({
    displayName: "styled__CardLink",
    componentId: "sc-94321db8-2"
})`
	display: block;
	height: 100%;

	p {
		${FontMixin({
    size: 'base',
    weight: 'regular'
})};

		color: ${({ theme  })=>theme.colors.primary.light};
		left: 0;
		position: absolute;
		text-align: center;
		top: calc(50% + 20px);
		width: 100%;

		::before {
			border: 1px solid ${({ theme  })=>theme.colors.primary.light};
			${BorderRadius({
    all: '50%'
})}
			content: '';
			height: 70px;
			left: 50%;
			top: -48px;
			position: absolute;
			transform: translate(-50%, -50%);
			width: 70px;
			z-index: ${({ theme  })=>theme.zIndex.low};
		}

		::after {
			color: ${({ theme  })=>theme.colors.primary.light};
			content: '+';
			font-size: 50px;
			line-height: 70px;
			${FontMixin({
    weight: 'light'
})}
			text-align: center;
			left: 50%;
			top: -48px;
			position: absolute;
			transform: translate(-50%, -50%);
			width: 70px;
			z-index: ${({ theme  })=>theme.zIndex.low};
		}
	}
`;

//# sourceMappingURL=styled.js.map